export const disableScrolling = () => (document.body.style.overflow = "hidden")
export const enableScrolling = () => (document.body.style.overflow = "auto")
export const setScrolling = (enabled: boolean) => {
  if (enabled) {
    enableScrolling()
  } else {
    disableScrolling()
  }
}
